import { useState } from 'react';
import { DataTable, Pagination } from '@/components';
import { columns } from './Columns';
import { useAuth } from '@/routes/AuthContext';
import { useListUsers } from '../hooks/usersApi';
import { PaginationState } from '@/components/Pagination';

export const UsersTable = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    page: 0,
    pageSize: 10,
  });
  const { user: currentUser } = useAuth();

  const { data: users, isFetching } = useListUsers({ pagination });

  if (!isFetching && !users?.data) {
    return <div>No users found</div>;
  }
  const transformedData =
    users?.data?.map((user) => ({
      ...user,
      isCurrentUser: user.emailAddress === currentUser?.email,
      providerType: user.providerType ?? undefined,
    })) ?? [];

  const totalCount = users?.totalCount ?? 0;

  return (
    <div className="container mx-auto p-10">
      <DataTable
        columns={columns}
        data={transformedData}
        isLoading={isFetching}
        pageSize={pagination.pageSize}
      />
      <Pagination
        pagination={pagination}
        setPagination={setPagination}
        totalCount={totalCount}
        pageSizeOptions={[10, 20]}
      />
    </div>
  );
};
